import type {
	ApiState,
	ApiSuccessResponse,
	ExtendedFetchOptions
} from '@/types/api-client'
import type { AddPregeneratedFeePayload, PregeneratedFeeType } from '@/types/api-client/pregenerated-fee'
import type { FetchOptions } from 'ofetch'

export function createPregeneratedFeesApi(
	request: <T>(endpoint: string, options?: ExtendedFetchOptions) => Promise<T | null>,
	createApiState: <T>(endpoint: string, options?: FetchOptions) => ApiState<T>
) {
	return {
		add: (contractId: number, payload: AddPregeneratedFeePayload, options: ExtendedFetchOptions = {}) => {
			return request<ApiSuccessResponse>(`/portal/contract/${contractId}/pregenerated-fee`, {
				method: 'POST',
				body: payload,
				...options
			})
		},

		getTypes: (options: ExtendedFetchOptions = {}): ApiState<PregeneratedFeeType[]> =>
			createApiState<PregeneratedFeeType[]>('/portal/contract/pregenerated-fee-types', options)
	}
}
